import React, { Component } from "react"
import styled from "styled-components"
import * as Dropzone from "dropzone"
import DownloadIcon from "../../../assets/images/download_icon.png"
Dropzone.autoDiscover = false

const dropzoneRemoveFileId = "dropzone-remove-file"

const AddImageButton = styled.div`
  position: relative;
  cursor: pointer;
  transition: 0.15s transform ease;
  margin-right: 8px;
`

const Button = styled.div`
  position: relative;
  width: 40px;
  height: 40px;
  display: block;
  right: 0;
  background-color: #ffffff;
  border-radius: 3px;
  border: solid 1px;
  box-shadow: 8px 8px 12px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: 0.15s transform ease;
  padding: 8px;
  margin-right: 8px;
  display: block;
`

const Icon = styled.img`
  position: relative;
  width: 100%;
  height: 100%;
`

class UploadImageBox extends Component {
  state = {
    uploadedComplete: false,
    file: null,
  }

  dropzoneDiv = React.createRef()

  componentDidMount() {
    this.dropzoneInstance = new Dropzone(this.dropzoneDiv.current, {
      url: "/",
      maxFiles: 1,
      maxThumbnailFilesize: 100,
      acceptedFiles: "image/*",
    })
    this.dropzoneInstance.on("complete", file => {
      this.setState({ file, uploadedComplete: true }, () => {
        const removeFileButton = document.getElementById(dropzoneRemoveFileId)
        removeFileButton.addEventListener("click", this.removeFile)
        this.props.addUploadedThumbnail(file.dataURL, file.height, file.width)
      })
    })
  }

  removeFile = () => {
    const { file } = this.state
    this.dropzoneInstance.removeFile(file)
    this.setState({ file: null, uploadedComplete: false }, () => {
      this.props.removeUploadedThumbnail(file.dataURL)
    })
  }

  render() {
    return (
      <AddImageButton ref={this.dropzoneDiv} className="upload-box dropzone">
        <div className="dz-message" data-dz-message style={{
          display: "flex",
          alignItems: "center",
        }}>
          <Button>
            <Icon src={DownloadIcon} />
          </Button>
          {" "}
          <span>
            {"UPLOAD IMAGE"}
          </span>
        </div>
      </AddImageButton>
    )
  }
}

export default UploadImageBox
